"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomIcon = void 0;

var _styles = require("./styles");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

var CustomIcon = function CustomIcon(props) {
  var id = props.id,
      key = props.key,
      className = props.className,
      type = props.type,
      transparent = props.transparent,
      size = props.size,
      borderType = props.borderType,
      icon = props.icon;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: icon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      id: id,
      className: "container-icon " + (["white", "whiteS2", "pink", "gray", "purple", "black"].includes(type) ? type : "white") + (transparent ? " transparent " : " fill ") + className,
      borderType: borderType,
      size: size,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFontawesome.FontAwesomeIcon, {
        icon: icon
      })
    }, key) : null
  });
};

exports.CustomIcon = CustomIcon;